import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGiphyComponent } from './simple-icons-giphy.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGiphyComponent ],
    exports:      [ SimpleIconsGiphyComponent ],
    bootstrap:    []
})
export class SimpleIconsGiphyModule {}
